module.exports = __webpack_public_path__ + "static/media/thumbnail_insorb-for-use.e63a435b.jpg";